<div class="simple-feature-view-container container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
  <fa-icon [ngClass]="{'green': value, 'red': !value}" icon="circle"></fa-icon>
  <span>{{label}}</span>
</div>
